import { partialContextCopyFor } from "./partial-context-copy";

/**
 * The clinic-facing notice for a turn that answered without part of the page
 * context (SCRUM-306). It mirrors `PausedNotice`, with one difference that is
 * the point of the slice: it sets NO `data-reason-code`, because the
 * `data-partial-context` frame carries no reason (Decision 14).
 */
export function PartialContextNotice({ refTypes }: { refTypes: readonly string[] }) {
  const copy = partialContextCopyFor(refTypes);

  return (
    <div
      role="status"
      data-testid="copilot-partial-context-notice"
      // The project's own tokens, not raw Tailwind colours: the design-tokens
      // ratchet in `src/lib/design-tokens.test.ts` refuses a file that adds
      // hard-coded colour.
      className="rounded-lg border border-app-warning bg-app-surface-muted p-3 text-sm text-app-fg"
    >
      <p className="font-medium text-app-fg-strong">{copy.title}</p>
      <p className="mt-1 text-app-fg-muted">{copy.body}</p>
    </div>
  );
}
